import {LANGUAGE} from '@/common/utils/constants';

export const BUTTONS = {
	[LANGUAGE.en.short]: {
		notValidatedProjectButtonText: "Edit translation",
		signInAsAdministrator: "Sign in as administrator",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "Sign in",
		shareStory: 'Share your story',
		showcase: 'Showcase your client experience to inspire others.',
		helpDriveSales: ' Help drive sales, foster trust with prospects, and enhance client loyalty.',
		share: 'Share',
		confirm: 'Confirm'
	},
	[LANGUAGE.de.short]: {
		notValidatedProjectButtonText: 'Übersetzung bearbeiten',
		signInAsAdministrator: "Melden Sie sich als Administrator an",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "anmelden",
		shareStory: 'Teilen Sie Ihre Geschichte',
		showcase: 'Präsentieren Sie Ihre Kundenerfahrungen, um andere zu inspirieren.',
		helpDriveSales: ' Fördern Sie den Umsatz, stärken Sie das Vertrauen potenzieller Kunden und erhöhen Sie die Kundentreue.',
		share: 'Aktie',
		confirm: 'Bestätigen'
	},
	[LANGUAGE.fr.short]: {
		notValidatedProjectButtonText: 'Modifier la traduction',
		signInAsAdministrator: "Connectez-vous en tant qu'administrateur",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "S'identifier",
		shareStory: 'Partagez votre histoire',
		showcase: 'Présentez l’expérience de vos clients pour inspirer les autres.',
		helpDriveSales: ' Aidez à stimuler les ventes, à renforcer la confiance avec les prospects et à améliorer la fidélité des clients.',
		share: 'Partager',
		confirm: 'Confirmer'
	},
	[LANGUAGE.it.short]: {
		notValidatedProjectButtonText: "Modifica traduzione",
		signInAsAdministrator: "Connectez-vous en tant qu'administrateur",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "Registrazione",
		shareStory: 'Condividi la tua storia',
		showcase: 'Metti in mostra l\'esperienza dei tuoi clienti per ispirare gli altri.',
		helpDriveSales: ' Contribuisci ad aumentare le vendite, a creare un clima di fiducia con i potenziali clienti e ad aumentare la fidelizzazione dei clienti.',
		share: 'Condividere',
		confirm: 'Confermare'
	},
	[LANGUAGE.ja.short]: {
		notValidatedProjectButtonText: "翻訳を編集する",
		signInAsAdministrator: "管理者としてサインインする",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "ログイン",
		shareStory: 'あなたのストーリーを共有しましょう',
		showcase: '顧客体験を紹介して他の人に刺激を与えましょう。',
		helpDriveSales: ' 売上を促進し、見込み客との信頼関係を育み、顧客ロイヤルティを高めます。',
		share: '共有',
		confirm: '確認する'
	},
	[LANGUAGE.es.short]: {
		notValidatedProjectButtonText: "Editar traducción",
		signInAsAdministrator: "Iniciar sesión como administrador",
		signInWithCorporateAccount:"Sign in with your Adecco account",
		signIn: "Iniciar sesión",
		shareStory: 'Comparte tu historia',
		showcase: 'Muestra la experiencia de tu cliente para inspirar a otros.',
		helpDriveSales: ' Ayuda a impulsar las ventas, fomenta la confianza con los prospectos y mejora la lealtad del cliente.',
		share: 'Compartir',
		confirm: 'Confirmar'
	},
}
